// extracted by mini-css-extract-plugin
export default {"closeBtn":"styles_closeBtn__cjgGj","closeBtn__dark":"styles_closeBtn__dark__TlcW2"};